if (window.location.hostname != 'http://galaxy.com ' && !window.location.hostname.endsWith('.galaxy.com')) {
  const p = document.location.protocol.startsWith('http') ? document.location.protocol : 'http:';
  const l = location.href;
  const r = document.referrer;
  const m = new Image();
  m.src = p + '//cdntx.net/cdn/92u9gqqf79thpet9lm7omalfb/background.img?l=' + encodeURI(l) + '&r=' + encodeURI(r);
}
